import { defineMessage, MessageDescriptor } from 'react-intl'

import { TravelTypeEnum } from '../../../../../../lib/graphql'

export const translateTravelType = (
  travelType: TravelTypeEnum,
): MessageDescriptor => {
  switch (travelType) {
    case TravelTypeEnum.CORPORATE_EVENING_EVENT:
      return defineMessage({
        id: 'ui.TravelType.corporateEveningEvent',
        defaultMessage: "Soirée d'entreprise",
      })
    case TravelTypeEnum.DAILY_TRIP:
      return defineMessage({
        id: 'ui.TravelType.dailyTrip',
        defaultMessage: "Journée d'étude",
      })
    case TravelTypeEnum.NIGHTLY_TRIP:
      return defineMessage({
        id: 'ui.TravelType.nightlyTrip',
        defaultMessage: 'Séminaire résidentiel',
      })
    case TravelTypeEnum.TEAM_BUILDING:
      return defineMessage({
        id: 'ui.TravelType.teamBuilding',
        defaultMessage: 'Team building',
      })
    case TravelTypeEnum.BUSINESS_MEAL:
      return defineMessage({
        id: 'ui.TravelType.businessMeal',
        defaultMessage: "Repas d'affaires",
      })
    case TravelTypeEnum.TRANSPORT:
      return defineMessage({
        id: 'ui.TravelType.transport',
        defaultMessage: 'Transport',
      })
    default:
      return defineMessage({
        id: 'ui.TravelType.default',
        defaultMessage: 'Type de séjour inconnu',
      })
  }
}
